import { render, staticRenderFns } from "./deep.vue?vue&type=template&id=f6ba867e&scoped=true&"
import script from "./deep.vue?vue&type=script&lang=js&"
export * from "./deep.vue?vue&type=script&lang=js&"
import style0 from "./deep.vue?vue&type=style&index=0&lang=css&"
import style1 from "./deep.vue?vue&type=style&index=1&id=f6ba867e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6ba867e",
  null
  
)

export default component.exports